var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 44,
    rx: 22,
    fill: "#109B32",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.002 14.744a.84.84 0 0 0 .003 1.175l3.64 3.679.084.074a.807.807 0 0 0 1.072-.076.835.835 0 0 0-.002-1.175l-3.64-3.68-.083-.073a.81.81 0 0 0-1.074.076Zm-9.286 6.432A.827.827 0 0 0 25 22c0 .458.366.83.818.83h14.383l-5.196 5.251-.074.085a.84.84 0 0 0 .072 1.09.81.81 0 0 0 1.156.002l6.6-6.67.073-.084a.836.836 0 0 0 .106-.82.817.817 0 0 0-.756-.515H25.818l-.102.007Z",
    fill: "#109B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit);
export default __webpack_public_path__ + "static/media/transit.d408fbbca58a11013d888596dcbb702d.svg";
export { ForwardRef as ReactComponent };